import {
  List,
  ListItem,
  ListItemButton,
  ListItemIcon,
  ListItemText,
  Menu,
  Typography,
} from "@mui/material";
import { useTranslation } from "react-i18next";
import { ReactComponent as DeleteIcon } from "../../../../../common/icons/delete.svg";
import { ReactComponent as LockIcon } from "../../../../../common/icons/lock.svg";
import { ReactComponent as CheckmarkIcon } from "../../../../../common/icons/checkGreen.svg";
import { ReactComponent as CrossRedIcon } from "../../../../../common/icons/crossRed.svg";
import { ReactComponent as EditIcon } from "../../../../../common/icons/editDark.svg";
import theme from "../../../../../theme";
import {
  PAYSLIP_APPROVED,
  PAYSLIP_DRAFT,
} from "../../../../salaries/constants";

type Props = {
  open: boolean;
  anchorEl: any;
  onClose: () => void;
  payslipId: string;
  isRowEditable?: boolean;
  isRowDeletable: boolean;
  onEditRow?: (payslipId: string) => void;
  onDeleteRow: (id: string) => void;
  onApprove: (id: string) => void;
  onRemoveApproval: (id: string) => void;
  onLock: (id: string) => void;
  itemStatus: string;
};

export const ActionMenu = ({
  open,
  anchorEl,
  onClose,
  payslipId,
  isRowEditable,
  isRowDeletable,
  onEditRow,
  onDeleteRow,
  onApprove,
  onRemoveApproval,
  onLock,
  itemStatus,
}: Props) => {
  const { t } = useTranslation();

  return (
    <Menu open={open} anchorEl={anchorEl} onClose={onClose}>
      <List dense disablePadding>
        {itemStatus !== PAYSLIP_APPROVED ? (
          <>
            <ListItem disablePadding>
              <ListItemButton
                disabled={itemStatus !== PAYSLIP_DRAFT}
                sx={{ paddingLeft: "13px", paddingRight: "13px" }}
                onClick={() => {
                  onApprove(payslipId);
                  onClose();
                }}
              >
                <ListItemIcon
                  sx={{ width: "13px", minWidth: "13px", marginRight: "13px" }}
                >
                  <CheckmarkIcon />
                </ListItemIcon>
                <ListItemText>
                  <Typography sx={{ color: theme.palette.success.main }}>
                    {t("payslips:approve")}
                  </Typography>
                </ListItemText>
              </ListItemButton>
            </ListItem>
            {onEditRow ? (
              <ListItem disablePadding>
                <ListItemButton
                  disabled={itemStatus !== PAYSLIP_DRAFT}
                  sx={{ paddingLeft: "13px", paddingRight: "13px" }}
                  onClick={() => {
                    onEditRow(payslipId);
                    onClose();
                  }}
                >
                  <ListItemIcon
                    sx={{
                      width: "13px",
                      minWidth: "13px",
                      marginRight: "13px",
                    }}
                  >
                    <EditIcon />
                  </ListItemIcon>
                  <ListItemText>
                    <Typography>{t("common:edit")}</Typography>
                  </ListItemText>
                </ListItemButton>
              </ListItem>
            ) : null}
            <ListItem disablePadding>
              <ListItemButton
                disabled={itemStatus !== PAYSLIP_DRAFT}
                sx={{
                  paddingLeft: "13px",
                  paddingRight: "13px",
                }}
                onClick={() => {
                  onLock(payslipId);
                  onClose();
                }}
              >
                <ListItemIcon
                  sx={{
                    width: "13px",
                    minWidth: "13px",
                    marginRight: "13px",
                  }}
                >
                  <LockIcon />
                </ListItemIcon>
                <ListItemText>
                  <Typography>{t("payslips:lock")}</Typography>
                </ListItemText>
              </ListItemButton>
            </ListItem>
            {isRowDeletable && (
              <ListItem disablePadding>
                <ListItemButton
                  sx={{
                    paddingLeft: "13px",
                    paddingRight: "13px",
                  }}
                  disabled={itemStatus !== PAYSLIP_DRAFT || !isRowEditable}
                  onClick={() => {
                    onDeleteRow(payslipId);
                    onClose();
                  }}
                >
                  <ListItemIcon
                    sx={{
                      width: "13px",
                      minWidth: "13px",
                      marginRight: "13px",
                    }}
                  >
                    <DeleteIcon />
                  </ListItemIcon>
                  <ListItemText>
                    <Typography sx={{ color: "#C50631" }}>
                      {t("delete")}
                    </Typography>
                  </ListItemText>
                </ListItemButton>
              </ListItem>
            )}
          </>
        ) : (
          <>
            <ListItem disablePadding>
              <ListItemButton
                sx={{ paddingLeft: "13px", paddingRight: "13px" }}
                onClick={() => {
                  onRemoveApproval(payslipId);
                  onClose();
                }}
              >
                <ListItemIcon sx={{ minWidth: "13px", marginRight: "13px" }}>
                  <CrossRedIcon />
                </ListItemIcon>
                <ListItemText>
                  <Typography sx={{ color: theme.palette.error.main }}>
                    {t("payslips:removeApproval")}
                  </Typography>
                </ListItemText>
              </ListItemButton>
            </ListItem>
            <ListItem disablePadding>
              <ListItemButton
                sx={{
                  paddingLeft: "13px",
                  paddingRight: "13px",
                }}
                onClick={() => {
                  onLock(payslipId);
                  onClose();
                }}
              >
                <ListItemIcon
                  sx={{
                    width: "13px",
                    minWidth: "13px",
                    marginRight: "13px",
                  }}
                >
                  <LockIcon />
                </ListItemIcon>
                <ListItemText>
                  <Typography>{t("payslips:lock")}</Typography>
                </ListItemText>
              </ListItemButton>
            </ListItem>
          </>
        )}
      </List>
    </Menu>
  );
};
